import { getProjectStateColor, getProjectStateString } from "@msuite/utils/projects";
import type { Tables } from "@msuite/utils/types";
import { useTranslation } from "../localization";
import { Tag } from "./tag";

/** Props Interface */
interface ProjectStateTagProps {
	state: Tables<"projects">["state"];
}

export function ProjectStateTag(props: ProjectStateTagProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Tag
			variant="plain"
			color={getProjectStateColor(props.state)}
		>
			{t(getProjectStateString(props.state))}
		</Tag>
	);
}
